import Layout from './Layout'

export default Layout



// WEBPACK FOOTER //
// ./src/features/ProvatePolicy/components/Layout/index.js